import type { AdminResourcesTranslationMessages } from './adminResourcesTranslationMessages';

export const adminResourcesLanguageItalian: AdminResourcesTranslationMessages = {
  labels: {
    name: 'Etichette',
    description: "Gestisci le etichette per controllare l'accesso alle risorse",
    helperText: 'Elenco delle etichette per questo record.',
    fields: {
      id: 'ID',
      labels: { id: 'Etichette', name: 'Etichette' },
      delete: 'Elimina',
      edit: 'Modifica',
      name: 'Nome',
      read: 'Visualizza',
    },
    operations: {
      create: "Crea un'etichetta",
      delete: "Elimina l'etichetta",
      edit: 'Modifica etichetta',
    },
  },
  callflows: {
    name: 'Dialplan',
    fields: {
      id: 'ID',
      name: 'Nome',
      number: 'Numero (opzionale)',
      priority: 'Priorità',
      description: 'Descrizione',
      labels: { id: 'Etichette', name: 'Etichette' },
      entry: 'Inizio',
      is_backup: 'Backup',
      last_edit: 'Ultima modifica',
      latest_callflow_version: 'Backup di',
      nodes: 'Nodi',
      assigned_inbound_e164s: 'Inbound E164',
    },
    operations: {
      create: 'Crea callflow',
      edit: 'Modifica callflow',
      delete: 'Elimina callflow',
    },
    helperTexts: {
      number:
        'Numero (opzionale) del callflow. Se impostato, può essere utilizzato per chiamare il callflow dagli interni tramite feature code',
      priority: "L'ordine di esecuzione del piano di chiamata. Più basso è il numero, prima verrà eseguito",
      assigned_inbound_e164s: 'Numeri in entrata che eseguiranno questo flusso di chiamata',
    },
  },
  mobility_configurations: {
    name: 'Configurazioni mobilità',
    helperTexts: {
      owner: 'Il proprietario del record',
    },
    fields: {
      id: 'ID',
      name: 'Nome',
      description: 'Descrizione',
      owner: 'Proprietario',
    },
  },
  latest_callflow_version: {
    name: 'Backup del dialplan',
  },
  carrier_mappings: {
    name: 'Trunk mapping',
    fields: {
      id: 'ID',
      name: 'Nome',
      description: 'Descrizione',
      labels: { id: 'Etichette', name: 'Etichette' },
      interface: 'Interfaccia',
      set_property: 'Proprietà da assegnare',
      match_property: 'Proprietà per il match',
      enabled: 'Abilita',
      rules: 'Regole',
    },
  },
  user_mappings: {
    name: 'Mapping utente',
    fields: {
      id: 'ID',
      name: 'Nome',
      interface: 'Interfaccia',
      description: 'Descrizione',
      enabled: 'Abilita',
      labels: { id: 'Etichette', name: 'Etichette' },
      match_property: 'Proprietà per il match',
      set_property: 'Proprietà da assegnare',
      rules: 'Regole',
    },
    user_inbound: 'Utente ingresso',
    user_outbound: 'Utente uscita',
    all: 'Tutti',
  },
  mappings: {
    name: 'Mapping',
    fields: {
      interface: 'Interfaccia',
      id: 'ID',
      name: 'Nome',
      description: 'Descrizione',
      enabled: 'Abilita',
      match_property: 'Proprietà per il match',
      enum_match_property: {
        caller_id_number: 'ID numero chamante',
        caller_id_name: 'ID nome chiamante',
        called_id_name: 'ID nome chiamato',
        called_id_number: 'ID numero chiamato',
        remote_network_addr: 'Network address remoto',
      },
      set_property: 'Proprietà da assegnare',
      enum_set_property: {
        caller_id_number: 'ID numero chamante',
        caller_id_name: 'ID nome chiamante',
        called_id_name: 'ID nome chiamato',
        called_id_number: 'ID numero chiamato',
        remote_network_addr: 'Network address remoto',
      },
      rules: 'Regole',
      labels: { id: 'Etichette', name: 'Etichette' },
      match_rule: 'Match',
      set_rule: 'Assegna',
    },
    operations: {
      create: 'Crea mappatura',
      edit: 'Modifica mappatura',
      delete: 'Elimina mappatura',
      sections: {
        details: 'Dettagli',
      },
    },
    helperTexts: {
      match_property: 'Proprietà della chiamata da usare per le regole di match',
      set_property: 'Richiama la proprietà da impostare in caso di match',
      rules: 'Regole di match/assegnamento, elaborate in ordine, la prima vince',
    },
  },
  queues: {
    name: 'Code',
    fields: {
      calendar: 'Calendario',
      call_recording_conf_id: 'Configurazione registrazione chiamate',
      callback_announce: 'Annuncio',
      callback_book_announce: 'Annuncio prenotazione',
      callback_success_announce: 'Annuncio successo',
      customsound: 'Suono personalizzato',
      description: 'Descrizione',
      labels: { id: 'Etichette', name: 'Etichette' },
      id: 'ID',
      name: 'Nome',
      type: 'Tipo',
      number: 'Numero',
      settings: {
        alarm_threshold: 'Soglia allarme',
        announce_agent: 'Annuncio agente',
        announce_frequency: 'Frequenza annuncio',
        announce_position: 'Annuncio posizione',
        announce_waiting: 'Annuncio attesa',
        busy_delay_time: 'Pausa se occupato',
        call_timeout: 'Timeout chiamata',
        callback_caller_id_number: 'Numero del chiamante del callback',
        callback_caller_number_regex: 'Regex numero chiamante',
        callback_delay: 'Intervallo callback',
        callback_enabled: 'Callback abilitato',
        callback_retention: 'Durata validità callback',
        callback_retries: 'Tentativi callback',
        callback_timeout: 'Timeout callback',
        callback_username: 'Nome utente callback',
        callback_wait_time: 'Tempo di attesa abilitazione callback',
        continue_on_answer: 'Continua dopo risposta',
        continue_on_max_waiters: 'Continua su massimo numero di chiamate in attesa',
        daily_reset_stats: 'Reset statistiche giornalieri',
        daily_reset_stats_time: 'Ora di reset delle statistiche giornaliere',
        exitkey: 'Uscita tramite DTMF',
        ignore_unavail: 'Ignora non disponibile',
        max_exten: 'Numero massimo di chiamate in attesa',
        max_wait_time: 'Tempo massimo di attesa',
        no_answer_delay_time: 'Pausa operatore per chiamata senza risposta',
        reject_delay_time: 'Pausa operatore per chiamata rifiutata',
        service_level: 'Livello di servizio',
        skip_empty: 'Continua senza agenti loggati',
        weight: 'Peso',
        wrap_up_time: 'Pausa operatore',
      },
      soundfile: 'File audio',
      strategy: 'Strategia',
      strategies: {
        all: 'Squilla Tutti',
        rr: 'A giro',
        fewest_calls: 'Meno Chiamati',
        rr_memory: 'A giro con memoria',
        mi: 'Meno Recente',
      },
    },
    operations: {
      create: 'Crea coda',
      edit: 'Modifica coda',
      delete: 'Elimina coda',
      sections: {
        details: 'Dettagli',
        callbacks: 'Callbacks',
        settings: 'Impostazioni',
      },
    },
    helperTexts: {
      number: 'Numero della coda',
      strategy: 'Strategia di distribuizione della chiamata agli agenti',
      callback_announce: "Il file audio dell'annuncio di richiamata",
      callback_book_announce: 'Il file audio di conferma della prenotazione della richiamata',
      callback_success_announce: 'Il file audio della richiamata andata a buon fine, prima di entrare in coda di nuovo',
      settings: {
        alarm_threshold: 'Numero di chiamate oltre il quale viene mostrato un avviso',
        announce_agent: "Quando l'agente risponde, viene riprodotto un messaggio con il suo numero identificativo",
        announce_frequency: 'Frequenza in secondi degli annunci in coda',
        announce_position:
          'Riproduce regolarmente un messaggio per informare il chiamante riguardo la sua posizione attuale',
        announce_waiting:
          'Riproduce regolarmente un messaggio per informare il chiamante riguardo al tempo di attesa previsto',
        busy_delay_time: 'Tempo di attesa se occupato in secondi',
        call_timeout: 'Durata massima dello squillo in secondi',
        callback_caller_id_number:
          'Numero identificativo del chiamante utilizzato per effettuare la chiamata in uscita',
        callback_caller_number_regex:
          'Regex utilizzata per convalidare il numero alternativo di richiamata composto dal chiamante',
        callback_delay: 'Quanti secondi aspettare prima di riprovare una richiamata',
        callback_enabled: 'Abilita il servizio di callback',
        callback_retention: 'Numero di ore in cui mantenere in coda una richiamata prenotata prima di rimuoverla',
        callback_retries: 'Numero di tentativi di callback',
        callback_timeout: 'Tempo di squillo, in secondi, prima di terminare la richiamata se non viene risposta',
        callback_username: 'Nome utente utilizzato per effettuare la chiamata in uscita',
        callback_wait_time:
          'Dopo il tempo di attesa specificato nella coda, il chiamante è ora in grado di premere un tasto e richiedere una richiamata',
        continue_on_answer: 'Se continuare il flusso del dialplan dopo la risposta di un agente',
        continue_on_max_waiters:
          'Se continuare il flusso del dialplan o terminare la chiamata quando si unisce a una coda in cui è già presente il numero massimo di chiamate in attesa',
        daily_reset_stats: "Abilita l'azzeramento giornaliero delle statistiche in tempo reale",
        daily_reset_stats_time: 'Ora del giorno in cui azzerare le statistiche in tempo reale',
        exitkey:
          'Se consentire o meno al chiamante di uscire dalla coda premendo il tasto 0 e passare al blocco successivo del dialplan',
        ignore_unavail: 'Ignora lo stato di irraggiungibilità degli agenti',
        max_exten: 'Numero massimo di chiamate in attesa nella coda. Il valore 0 significa illimitato',
        max_wait_time:
          'Tempo in secondi in cui una chiamata attenderà nella coda prima di essere instradata al blocco successivo. Il valore 0 significa illimitato',
        no_answer_delay_time: 'Pausa operatore in secondi nel caso di chiamata non risposta',
        reject_delay_time: 'Pausa operatore in secondi nel caso di chiamata rifiutata',
        service_level: 'Statistiche del livello di servizio. Il valore 0 significa che non ci sono statistiche',
        skip_empty: 'Salta la coda senza agenti registrati',
        weight:
          "Le code con peso maggiore hanno priorità nell'assegnamento degli agenti disponibili, quando lo stesso agente appartiene a più code. Il valore 0 disabilita questa funzione",
        wrap_up_time: 'Pausa operatore in secondi',
      },
    },
  },
  agents: {
    name: 'Agenti',
    type: 'Tipo',
    fields: {
      group: 'Gruppo',
      user: 'Utente',
      labels: { id: 'Etichette', name: 'Etichette' },
      name: 'Nome',
      queue: 'Coda',
      settings: {
        busy_delay_time: 'Tempo di attesa occupato',
        call_timeout: 'Timeout chiamata',
        initial_paused: 'Inizialmente in pausa',
        no_answer_delay_time: 'Tempo di attesa risposta negativa',
        position: 'Posizione',
        reject_delay_time: 'Tempo di attesa rifiuto',
        wrap_up_time: 'Tempo di chiusura',
      },
    },
    operations: {
      create: 'Crea agente',
      edit: 'Modifica agente',
      delete: 'Elimina agente',
      assign_agents: 'Assegna agenti',
      sections: {
        details: 'Dettagli',
        settings: 'Impostazioni',
      },
    },
    helperTexts: {
      bulkAssignLabels: 'Elenco di etichette da assegnare agli agenti appena aggiunti',
      settings: {
        busy_delay_time:
          "Numero di secondi da attendere prima che una chiamata venga inoltrata a un agente se viene rilevato un tono di occupato dal telefono dell'agente",
        call_timeout: 'Numero di secondi in cui un agente squilla',
        no_answer_delay_time:
          'Numero di secondi di attesa prima che una chiamata venga inoltrata a un agente se questo non risponde',
        position: "Posizione dell'agente nella coda",
        reject_delay_time:
          "Numero di secondi da attendere prima che una chiamata venga inoltrata a un agente se viene rilevato un tono di rifiuto dal telefono dell'agente",
        wrap_up_time:
          "Numero di secondi in cui l'agente deve svolgere le attività post-chiamata al termine della conversazione",
      },
    },
  },
  'presence/users': {
    name: 'Utenti presenza',
    fields: {
      id: 'ID',
      firstname: 'Nome',
      lastname: 'Cognome',
      middlename: 'Secondo nome',
      username: 'Nome utente',
    },
  },
  queue_measurements: {
    name: 'Statistiche della coda',
    fields: {
      id: 'ID',
      name: 'Nome',
      description: 'Descrizione',
      labels: { id: 'Etichette', name: 'Etichette' },
    },
  },
  call_reports: {
    name: 'Report chiamate',
  },
  call_recordings: {
    name: 'Registrazioni chiamate',
    fields: {
      caller_id_name: 'Nome chiamante',
      caller_id_number: 'Numero chiamante',
      called_id_name: 'Nome chiamato',
      called_id_number: 'Numero chiamato',
      start_time: 'Inizio',
      end_time: 'Fine',
      account: 'Account',
      id: 'ID',
      recording_uuid: 'UUID registrazione',
      url: 'URL',
      user_id: 'ID utente',
      status: 'Stato',
      labels: { name: 'Etichette', id: 'ID etichetta' },
    },
    statuses: {
      recording: 'In registrazione',
      completed: 'Completata',
      failed: 'Fallita',
    },
    unavailable: 'Registrazione non disponibile',
  },
  'me/call_recordings': {
    name: 'Registrazioni chiamate',
  },
  call_recording_confs: {
    name: 'Configurazioni registrazione chiamate',
    fields: {
      name: 'Nome',
      description: 'Descrizione',
      soundfile_id: 'File audio annuncio',
      labels: { id: 'Etichette', name: 'Etichette' },
      call_recording_labels: 'Etichette registrazione',
      settings: {
        announce: 'Riproduci annuncio',
        bip: 'Riproduci segnale acustico',
        asr: 'Abilita riconoscimento vocale',
        format_file: 'Formato registrazione',
        name_file: 'Modello nome file',
        hash_file: 'Crea hash del file',
        crypto: 'Cifra registrazione',
        crypto_password: 'Password cifratura',
        crypto_password_confirmation: 'Conferma password cifratura',
        ek: 'Chiave di cifratura',
        ek_recovery: 'Abilita recupero chiave',
      },
      types: {
        in: 'In entrata',
        outbound_local: 'In uscita locale',
        outbound_external: 'In uscita esterna',
        onetouch: 'One-touch',
      },
    },
    operations: {
      create: 'Crea configurazione registrazione',
      edit: 'Modifica configurazione registrazione',
      delete: 'Elimina configurazione registrazione',
      sections: {
        details: 'Dettagli',
        settings: 'Impostazioni',
        users: 'Utenti',
      },
      manage_users: 'Gestisci assegnazioni utente',
    },
  },
  user_call_recording_confs: {
    name: 'Assegnazioni registrazione utente',
    fields: {
      id: 'ID',
      type: 'Tipo chiamata',
      user: 'Utente',
    },
    confirmDelete: {
      title: 'Elimina assegnazione registrazione',
      content: 'Sei sicuro di voler eliminare questa assegnazione di registrazione?',
    },
  },
  queue_call_sessions: {
    name: 'Sessioni chiamate in coda',
    fields: {
      id: 'ID',
      answer_time: 'Durata risposta (s)',
      answer_ts: 'Timestamp risposta',
      answered_by: 'Risposta da',
      caller_id_name: 'Nome ID chiamante',
      caller_id_number: 'Numero ID chiamante',
      called_id_number: 'Numero ID chiamato',
      first_queue: 'Prima coda',
      final_queue: 'Coda finale',
      final_exit_cause: 'Causa uscita finale',
      first_join_ts: 'Orario primo ingresso',
      last_leave_ts: 'Orario ultima uscita',
      total_time: 'Tempo totale in coda (s)',
      total_queues: 'Code attraversate',
      labels: { id: 'Etichette', name: 'Etichette' },
      actions: 'Azioni',
    },
    actions: {
      viewQueueEvents: 'Eventi coda',
      viewAgentEvents: 'Eventi agente',
    },
  },
  queue_call_session_events: {
    name: 'Eventi sessione chiamata coda',
    fields: {
      id: 'ID',
      caller_id_name: 'Nome ID chiamante',
      caller_id_number: 'Numero ID chiamante',
      called_id_number: 'Numero ID chiamato',
      queue_name: 'Nome coda',
      join_ts: 'Orario ingresso',
      leave_ts: 'Orario uscita',
      exit_cause: 'Causa uscita',
      answered_by: 'Risposta di',
      answer_ts: 'Orario risposta',
      answer_time: 'Durata risposta (s)',
      labels: { id: 'Etichette', name: 'Etichette' },
    },
  },
  queue_call_session_agent_events: {
    name: 'Eventi agente sessione coda',
    fields: {
      id: 'ID',
      agent_name: 'Nome agente',
      caller_id_name: 'Nome ID chiamante',
      queue_name: 'Nome coda',
      originate_ts: 'Orario origine',
      answer_ts: 'Orario risposta',
      end_ts: 'Orario fine',
      exit_cause: 'Causa uscita',
      answer_time: 'Durata risposta (s)',
      caller_id_number: 'Numero ID chiamante',
      called_id_number: 'Numero ID chiamato',
      group_name: 'Nome gruppo',
      labels: { id: 'Etichette', name: 'Etichette' },
    },
  },
  auth_providers: {
    name: 'Auth Providers',
    description: 'Visualizza e gestisci i provider di autenticazione',
    fields: {
      name: 'Nome',
      description: 'Descrizione',
      client_id: 'Client id',
      client_secret: 'Client secret',
      configuration_endpoint: 'Endpoint della configurazione',
      enabled: 'Attiva',
      issuer: 'Issuer',
      scopes: 'Ambiti',
      labels: { id: 'Etichette', name: 'Etichette' },
      button_text: 'Etichetta del pulsante di accesso (es. Accedi con Google)',
      policies: { login: 'Abilita login', token_exchange: 'Abilita scambio con token esterno' },
    },
    operations: {
      create: 'Crea provider',
      edit: 'Modifica provider',
      delete: 'Elimina provider',
      sections: {
        providerConfig: 'Configurazione',
        advanced: 'Avanzate',
      },
    },
    configEpValidation: {
      invalid: 'Endpoint non valido',
      valid: 'Endpoint valido',
    },
    labels: {
      enabled: 'Attivo',
      loginEnabled: 'Login abilitato',
      tokenExchangeEnabled: 'Token exchange abilitato',
    },
  },
  oauth_applications: {
    name: 'Applicazioni OAuth',
    description: 'Visualizza e gestisci le applicazioni OAuth',
    fields: {
      name: 'Nome',
      client_id: 'Client ID',
      client_secret: 'Client Secret',
      redirect_uri: 'URI di reindirizzamento',
      scopes: 'Ambiti',
      enabled: 'Attiva',
      labels: { id: 'Etichette', name: 'Etichette' },
    },
    helperTexts: {
      redirect_uri: "URI assoluto a cui l'utente verrà reindirizzato dopo l'autorizzazione o il rifiuto dell'accesso",
    },
    operations: {
      create: 'Crea applicazione',
      edit: 'Modifica applicazione',
      delete: 'Elimina applicazione',
      sections: {
        applicationConfig: 'Configurazione applicazione',
      },
    },
    labels: {
      enabled: 'Attivo',
    },
  },
  call_sessions: {
    name: 'CDR',
    fields: {
      id: 'ID',
      caller_id_number: 'Numero ID chiamante',
      caller_id_name: 'Nome ID chiamante',
      called_id_number: 'Numero ID chiamato',
      called_id_name: 'Nome ID chiamato',
      answer_time: 'Orario risposta',
      creation_time: 'Orario creazione',
      hangup_cause: 'Causa di disconnessione',
      hangup_time: 'Orario di disconnessione',
      account: 'Account',
      called_account: 'Account chiamato',
      called: 'Chiamato',
      caller: 'Chiamante',
      labels: { id: 'Etichette', name: 'Etichette' },
      hangupCauses: {
        ACCESS_INFO_DISCARDED: 'Informazioni di accesso scartate',
        ALLOTTED_TIMEOUT: 'Timeout nella risposta',
        ATTENDED_TRANSFER: 'Trasferimento assistito',
        BAD_IDENTITY_INFO: 'Informazioni identità errate',
        BEARERCAPABILITY_NOTAUTH: 'Bearer capability non autorizzata',
        BEARERCAPABILITY_NOTAVAIL: 'Bearer capability non disponibile',
        BEARERCAPABILITY_NOTIMPL: 'Bearer capability non implementata',
        BLIND_TRANSFER: 'Trasferimento cieco',
        BOWOUT: 'Uscita dalla chiamata',
        BUSY_EVERYWHERE: 'Occupato ovunque',
        CALL_AWARDED_DELIVERED: 'Chiamata assegnata e consegnata',
        CALL_REJECTED: 'Chiamata rifiutata',
        CHAN_NOT_IMPLEMENTED: 'Tipo di canale non disponibile',
        CHANNEL_UNACCEPTABLE: 'Canale non compatibile',
        CRASH: 'Crash',
        DECLINE: 'Chiamata rifiutata',
        DESTINATION_OUT_OF_ORDER: 'Destinazione fuori servizio',
        DOES_NOT_EXIST_ANYWHERE: 'Inesistente',
        EXCHANGE_ROUTING_ERROR: 'Errore di instradamento nella rete',
        FACILITY_NOT_IMPLEMENTED: 'Servizio supplementare non implementato',
        FACILITY_NOT_SUBSCRIBED: 'Servizio supplementare non sottoscritto',
        FACILITY_REJECTED: 'Servizio supplementare non disponibile',
        GATEWAY_DOWN: 'Gateway non disponibile',
        IE_NONEXIST: 'IE inesistente',
        INCOMING_CALL_BARRED: 'Chiamata in entrata bloccata',
        INCOMPATIBLE_DESTINATION: 'Destinazione incompatibile',
        INTERWORKING: 'Chiusura normale',
        INVALID_CALL_REFERENCE: 'Riferimento chiamata non valido',
        INVALID_GATEWAY: 'Gateway non valido',
        INVALID_IDENTITY: 'Identità non valida',
        INVALID_IE_CONTENTS: 'Contenuto IE non valido',
        INVALID_MSG_UNSPECIFIED: 'Messaggio invalido',
        INVALID_NUMBER_FORMAT: 'Formato numero non valido',
        INVALID_PROFILE: 'Profilo non valido',
        INVALID_URL: 'URL non valido',
        LOSE_RACE: 'Risposta altrove',
        MANAGER_REQUEST: 'Chiusa dalla centrale',
        MANDATORY_IE_LENGTH_ERROR: 'Errore lunghezza IE obbligatorio',
        MANDATORY_IE_MISSING: 'IE obbligatorio mancante',
        MEDIA_TIMEOUT: 'Timeout media',
        MESSAGE_TYPE_NONEXIST: 'Tipo di messaggio inesistente',
        NETWORK_OUT_OF_ORDER: 'Rete fuori servizio',
        NO_ANSWER: 'Nessuna risposta',
        NO_IDENTITY: 'Identità assente',
        NO_PICKUP: 'Nessun pickup',
        NO_ROUTE_DESTINATION: 'Nessuna rotta verso la destinazione',
        NO_ROUTE_TRANSIT_NET: 'Nessuna rotta tramite rete di transito',
        NO_USER_RESPONSE: 'Nessuna risposta',
        NORMAL_CIRCUIT_CONGESTION: 'Congestione',
        NORMAL_CLEARING: 'Chiusura normale',
        NORMAL_TEMPORARY_FAILURE: 'Guasto temporaneo',
        NORMAL_UNSPECIFIED: 'Chiusura normale',
        NOT_ACCEPTABLE: 'Non accettabile',
        NUMBER_CHANGED: 'Numero cambiato',
        ORIGINATOR_CANCEL: 'Annullamento dal chiamante',
        OUTGOING_CALL_BARRED: 'Chiamata in uscita bloccata',
        PICKED_OFF: 'Chiamata presa altrove',
        PRE_EMPTED: 'Preempted',
        PROGRESS_TIMEOUT: 'Progress timeout',
        PROTOCOL_ERROR: 'Errore di protocollo',
        RECOVERY_ON_TIMER_EXPIRE: 'Timer scaduto',
        REDIRECTION_TO_NEW_DESTINATION: 'Reindirizzamento a nuova destinazione',
        REJECT_ALL: 'Rifiuta tutto',
        REQUESTED_CHAN_UNAVAIL: 'Canale richiesto non disponibile',
        RESPONSE_TO_STATUS_ENQUIRY: 'Risposta a richiesta di stato',
        SERVICE_NOT_IMPLEMENTED: 'Servizio non implementato',
        SERVICE_UNAVAILABLE: 'Servizio non disponibile',
        SRTP_READ_ERROR: 'Errore SRTP',
        STALE_DATE: 'Data scaduta',
        SUBSCRIBER_ABSENT: 'Utente non raggiungibile',
        SUCCESS: 'Successo',
        SWITCH_CONGESTION: 'Congestione',
        SYSTEM_SHUTDOWN: 'Sistema in spegnimento',
        UNALLOCATED_NUMBER: 'Numero inesistente',
        UNSUPPORTED_CERTIFICATE: 'Certificato non supportato',
        UNWANTED: 'Indesiderato',
        USER_BUSY: 'Occupato',
        USER_CHALLENGE: 'User challenge',
        USER_NOT_REGISTERED: 'Utente non registrato',
        WRONG_CALL_STATE: 'Stato della chiamata errato',
        WRONG_MESSAGE: 'Messaggio errato',
      },
    },
    info: {
      title: 'Dettagli della sessione di chiamata',
    },
    errors: {
      loadFailed: 'Impossibile caricare i dettagli della sessione di chiamata.',
    },
  },
  call_session_events: {
    name: 'Eventi sessione di chiamata',
    fields: {
      id: 'ID',
      detailsLabel: 'Dettagli',
      details: {
        account: 'Account',
        action: 'Azione',
        answer_time: 'Orario risposta',
        called_account: 'Account chiamato',
        create_time: 'Orario creazione',
        hangup_time: 'Orario chiusura',
        type: 'Tipo',
        to: 'A',
        transferor: 'Trasferente',
        description: 'Descrizione',
        mobility_username: 'Nome utente mobilità',
        digit: 'Cifra',
        called_number: 'Numero chiamato',
        reason: 'Causa',
        result: 'Risultato',
        carrier_name: 'Carrier',
      },
      parent_channel_id: 'ID canale padre',
      channel_id: 'ID canale',
      ts_event: 'Orario evento',
      labels: { id: 'Etichette', name: 'Etichette' },
    },
    viewModes: {
      hierarchy: 'Schede dettagliate',
      tree: 'Vista ad albero',
    },
    summary: {
      channelTitle: 'Canale %{channel}',
      parent: 'Canale padre',
      parentFallback: 'Canale radice',
      unknownChannel: 'Canale sconosciuto',
      firstEvent: 'Primo evento',
      lastEvent: 'Ultimo evento',
      eventCount: '%{smart_count} evento |||| %{smart_count} eventi',
    },
    event: {
      timestamp: 'Data e ora',
      noDetails: 'Nessun dettaglio aggiuntivo',
      unknownType: 'Tipo sconosciuto',
    },
    types: {
      agent_call: 'Chiamata agente',
      user_call: 'Chiamata utente',
      outbound_call: 'Chiamata in uscita',
      queue: 'Coda',
      mobility: 'Mobilità',
      call_me: 'Chiamami',
      calendar: 'Calendario',
      presence_router: 'Router di presenza',
      disconnect: 'Disconnessione',
    },
    status: {
      answered: 'Risposto',
      unanswered: 'Non risposto',
    },
    empty: {
      title: 'Nessun evento disponibile',
      description: 'Le attività della sessione di chiamata verranno mostrate qui non appena disponibili.',
    },
    errors: {
      loadFailed: 'Impossibile caricare gli eventi della sessione di chiamata.',
    },
    toggleAdvanced: 'Mostra informazioni avanzate',
  },
  encryption_configurations: {
    name: 'Chiavi di Crittografia dello Storage',
    fields: {
      id: 'ID',
      domain_id: 'Dominio',
      name: 'Nome',
      description: 'Descrizione',
      enabled: 'Abilitato',
      labels: { id: 'Etichette', name: 'Etichette' },
      metadata: {
        type: 'Tipo',
      },
    },
    operations: {
      create: 'Crea configurazione di crittografia',
      delete: 'Elimina configurazione di crittografia',
      edit: 'Modifica configurazione di crittografia',
      sections: {
        details: 'Dettagli',
        configuration: 'Configurazione',
      },
    },
    helperTexts: {
      enabled: 'Solo una configurazione puo essere abilitata alla volta.',
    },
  },
  storage_configurations: {
    name: 'Configurazioni di Storage Esterni',
    fields: {
      id: 'ID',
      domain_id: 'Dominio',
      name: 'Nome',
      description: 'Descrizione',
      enabled: 'Abilitato',
      labels: { id: 'Etichette', name: 'Etichette' },
      metadata: {
        type: 'Tipo',
        endpoint_scheme: "Schema dell'endpoint",
        endpoint_host: "Host dell'endpoint",
        endpoint_port: "Porta dell'endpoint",
        region: 'Regione',
        bucket: 'Bucket',
        access_key: 'Chiave di accesso',
        secret_key: 'Chiave segreta',
        ssl_verify: 'Verifica certificato SSL',
      },
    },
    operations: {
      create: 'Crea configurazione di storage',
      delete: 'Elimina configurazione di storage',
      edit: 'Modifica configurazione di storage',
      sections: {
        details: 'Dettagli',
        s3_configuration: 'Configurazione S3',
      },
    },
    helperTexts: {
      enabled: 'Solo una configurazione puo essere abilitata alla volta.',
      immutable: 'Questi campi non potranno essere modificati dopo il salvataggio.',
    },
  },
};
